<script>
  export default {
    props: {
      customClass: {
        type: String,
        default: 'tw-fill-primary',
      },
      disableHover: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      width() {
        return 23
      },
      height() {
        return 16
      },
      viewBox(){
        return `0 0 ${this.width} ${this.height}`
      }
    }
  }
</script>

<template>
  <svg
    :class="[customClass, { 'no-hover': disableHover }]"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.7975 6.41824C20.8287 6.45914 20.8614 6.50133 20.8953 6.54502C21.3732 7.16098 22.0953 8.09189 22.0952 9.86973V12.0787C22.0952 12.7885 21.5142 13.366 20.8 13.366H18.9161C18.7864 14.8398 17.5385 15.9999 16.0225 15.9999C14.5064 15.9999 13.2587 14.8398 13.1289 13.366H8.98375C8.85404 14.8398 7.60618 15.9999 6.09012 15.9999C4.57407 15.9999 3.32631 14.8398 3.19655 13.366H0.719794C0.322891 13.366 0 13.0641 0 12.6929V10.3793C0 10.0082 0.322891 9.70629 0.719794 9.70634H11.9969C12.2066 9.70634 12.3595 9.66065 12.4391 9.57417C12.5113 9.49587 12.5041 9.40484 12.5038 9.401L12.5031 9.38794V3.03384L12.507 3.01863C12.5909 2.69255 12.8852 2.46482 13.2226 2.46482H13.6948C14.0276 2.46482 14.3042 2.46148 14.307 2.46143H17.2022C17.7886 2.46143 18.3782 2.81324 19.0049 3.53708C19.2857 3.86149 19.543 4.33063 19.8153 4.8273L19.8154 4.82739C20.0932 5.33396 20.408 5.90812 20.7975 6.41824ZM16.0224 14.1888C16.6198 14.1888 17.1058 13.706 17.1058 13.1124C17.1058 12.5188 16.6198 12.0359 16.0224 12.0359C15.4253 12.0359 14.9395 12.5188 14.9395 13.1124C14.9395 13.706 15.4253 14.1888 16.0224 14.1888ZM19.5968 7.50786C19.5742 7.54502 19.5096 7.56103 19.4114 7.55479L14.434 7.55454V3.51897H16.5859C17.1649 3.51897 17.5752 3.76949 18.0021 4.38365C18.286 4.79213 19.0377 6.07825 19.076 6.14388C19.1015 6.19274 19.1276 6.24236 19.154 6.29245L19.1579 6.29974L19.1584 6.30073L19.1584 6.30075C19.3753 6.71277 19.7024 7.33439 19.5968 7.50786ZM7.17347 13.1124C7.17347 12.5188 6.6875 12.0359 6.09014 12.0359C5.49298 12.0359 5.00716 12.5188 5.00716 13.1124C5.00716 13.706 5.49298 14.1888 6.09014 14.1888C6.6875 14.1888 7.17347 13.706 7.17347 13.1124Z" />
    <path
      d="M1.2737 8.61516H4.86385C5.22777 8.61516 5.5238 8.33912 5.5238 7.99977V5.53824C5.5238 5.19889 5.22777 4.92285 4.86385 4.92285H1.2737C0.909775 4.92285 0.613747 5.19889 0.613747 5.53824V7.99977C0.613747 8.33912 0.909828 8.61516 1.2737 8.61516Z" />
    <path
      d="M6.79751 8.61516H10.3877C10.7516 8.61516 11.0476 8.33912 11.0476 7.99977V5.53824C11.0476 5.19889 10.7516 4.92285 10.3877 4.92285H6.79751C6.43358 4.92285 6.13755 5.19889 6.13755 5.53824V7.99977C6.13755 8.33912 6.43364 8.61516 6.79751 8.61516Z" />
    <path
      d="M1.2737 3.69231H4.86385C5.22777 3.69231 5.5238 3.41627 5.5238 3.07692V0.615385C5.5238 0.276037 5.22777 0 4.86385 0H1.2737C0.909775 0 0.613747 0.276037 0.613747 0.615385V3.07692C0.613747 3.41627 0.909828 3.69231 1.2737 3.69231Z" />
    <path
      d="M6.79751 3.69231H10.3877C10.7516 3.69231 11.0476 3.41627 11.0476 3.07692V0.615385C11.0476 0.276037 10.7516 0 10.3877 0H6.79751C6.43358 0 6.13755 0.276037 6.13755 0.615385V3.07692C6.13755 3.41627 6.43364 3.69231 6.79751 3.69231Z" />
  </svg>
</template>
